export const ReportConfirm = {
    warningDelay: '큰 부하가 발생할 수 있습니다.',
    confirm: '정말 진행하시겠습니까?',
}

export const SettingConfirm = {
    warningDelete: '정말 삭제하시겠습니까?',
}